//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { IGetTopHashtagRecommendationsResponse } from '@apis/gateway-instagram/instagramHashtagRecommendationsApiModel';
import InstagramHashtag from '@models/InstagramHashtag';
import { makeParams } from '@utils/makeParams';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

function hashtagRecommendationsFetch(
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> {
  return serializedGatewayFetch(
    'instagram_dashboard_gateway',
    `/api/v1/hashtag-recommendations${endpoint}`,
    init,
  );
}

/**
 * Gets list of Instagram top hashtag recommendations
 * for the current client's connected Instagram account
 *
 * GET /api/v1/hashtag-recommendations/top-recommendations
 *
 * @param limit the maximum number or hashtag recommendations returned
 */
export async function getTopHashtagRecommendations(
  limit: number,
): Promise<InstagramHashtag[]> {
  const params = makeParams({ limit });
  const res = await hashtagRecommendationsFetch(
    `/top-recommendations/?${params}`,
  );
  const topRecommendedHashtagsResponse = await res.json<IGetTopHashtagRecommendationsResponse>();

  return topRecommendedHashtagsResponse.data;
}
